const { Decimal } = require('decimal.js');


/**
 * Get the allocation bounce (min/max) in percentage
 */
export default function getAllocationBounce({ prevAllocation = 0 } = {}) {
  const lastCoinbaseRatio = new Decimal(100 - prevAllocation);
  const correctionCap = new Decimal(85); // env.coinbaseCorrectionCap = 15
  const globalRatioMin = new Decimal(10); // env.lowerCoinbaseBound = 90
  const localRatioMin = lastCoinbaseRatio.times(correctionCap).div(100).floor();
  const localRatioMax = lastCoinbaseRatio.times(100).div(correctionCap).floor();
  
  const max = 100 - Decimal.max(globalRatioMin, localRatioMin).toNumber();
  const min = 100 - Decimal.min(new Decimal(100), localRatioMax).toNumber();
  return {
    min,
    max,
  };
}
